<template>
  <vx-card
    title="Kunjungan Berdasarkan Layanan"
    subtitle="Data disajikan dalam periode tahun"
  >
    <div class="flex space-x-4">
      <vs-select
        v-model="filterYear"
        class="vx-col md:w-1/5 mb-base"
        @change="getChartData()"
      >
        <vs-select-item
          v-for="(item, index) in yearList"
          :key="index"
          :value="item"
          :text="'Tahun ' + item"
          class="w-full"
        />
      </vs-select>

      <vs-select
        v-model="filterMonth"
        class="vx-col md:w-1/5 mb-base"
        @change="getChartData()"
      >
        <vs-select-item
          v-for="(item, index) in monthList"
          :key="index"
          :value="item.value"
          :text="item.text"
          class="w-full"
        />
      </vs-select>
    </div>
    <global-wrapper
      :loading="loading"
      :loadingType="'avatar-three-line'"
      :loadingList="4"
      :scrollable="true"
      height="500px"
    >
      <Bar
        v-if="chartData"
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="'visitor-services-chart'"
        :width="width"
        :height="height"
      />
    </global-wrapper>
  </vx-card>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

export default {
  name: 'ServiceByInstancy',
  components: { Bar },
  data() {
    return {
      loading: true,
      chartOptions: {
        responsive: true,
        indexAxis: 'x'
      },
      chartData: {},
      width: 400,
      height: 150,
      filterYear: new Date().getFullYear(),
      filterMonth: null,
      yearList: [2021, 2022, 2023,2024],
      monthList: [
        { value: null, text: 'Semua Bulan'},
        { value: 1, text: 'Januari' },
        { value: 2, text: 'Februari' },
        { value: 3, text: 'Maret' },
        { value: 4, text: 'April' },
        { value: 5, text: 'Mei' },
        { value: 6, text: 'Juni' },
        { value: 7, text: 'Juli' },
        { value: 8, text: 'Agustus' },
        { value: 9, text: 'September' },
        { value: 10, text: 'Oktober' },
        { value: 11, text: 'November' },
        { value: 12, text: 'Desember' }
      ]
    }
  },
  mounted(){
    this.getChartData();
  },
  methods: {
    async getChartData(){
      const res = await this.$httpMpp.get('/app/statistic/visitor-by-services-data', {params : {year: this.filterYear, month: this.filterMonth}});
      let data = res.data.data;
      let colors = data.dataset.map(function (){
        return 'rgb(54, 162, 235)';
      });

      this.chartData = {
        labels: data.labels,
        datasets: [{
          label: `Jumlah Kunjungan`,
          data: data.dataset,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
          barThickness: 30
        }]
      }
      this.loading = false;
    }
  }
}
</script>
